import PropTypes from 'prop-types';
import {
  OrdersHeaderWrapper,
  OrdersHeaderFilterWrapper,
  OrdersHeaderFilterItemWrapper,
  OrdersHeaderFilterItem,
  OrdersHeaderCreateOrderButton,
} from './OrdersHeader.style';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const OrdersHeader = ({
  showCreateOrderBtn,
  stringsData,
  selectedStatusFilter,
  ordersStatusFilterList,
  handleOrderStatusFilterClick,
}) => (
  <OrdersHeaderWrapper>
    <OrdersHeaderFilterWrapper>
      {ordersStatusFilterList.map(ordersFilterItem => {
        const isFilterSelected = ordersFilterItem.key === selectedStatusFilter.key;

        return (
          <OrdersHeaderFilterItemWrapper
            key={ordersFilterItem.key}
            selected={isFilterSelected}
            onClick={() => handleOrderStatusFilterClick(ordersFilterItem)}
          >
            <OrdersHeaderFilterItem>{ordersFilterItem.name}</OrdersHeaderFilterItem>
          </OrdersHeaderFilterItemWrapper>
        );
      })}
    </OrdersHeaderFilterWrapper>
    {showCreateOrderBtn && (
      <OrdersHeaderCreateOrderButton as="button">
        {stringsData.ordersHeader.createOrdersButton}
      </OrdersHeaderCreateOrderButton>
    )}
  </OrdersHeaderWrapper>
);
OrdersHeader.propTypes = {
  showCreateOrderBtn: PropTypes.bool,
  stringsData: PropTypes.shape({
    ordersHeader: PropTypes.shape({
      allOrdersFilterItem: PropTypes.string,
      createOrdersButton: PropTypes.string,
    }),
  }).isRequired,
  selectedStatusFilter: PropTypes.shape({
    key: PropTypes.number,
  }).isRequired,
  ordersStatusFilterList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  handleOrderStatusFilterClick: PropTypes.func.isRequired,
};

OrdersHeader.defaultProps = {
  showCreateOrderBtn: false,
};

export default OrdersHeader;
